import {Box} from '@mui/material';
import type * as React from 'react';
import LogoImage from '../../images/glenbrook225.png';

const Logo = () : React.ReactElement => {
    return <Box
        component="img"
        alt="GLENBROOK HIGH SCHOOLS"
        src={LogoImage}
        sx={{
            maxWidth: '125px',
            m: 2,
        }}
    />;
};

export default Logo;
